// extracted by mini-css-extract-plugin
export default {"general":"general_general__3MyTf","sidebarComponents":"general_sidebarComponents__ZcBXw","ctnPenChat":"general_ctnPenChat__3dfq6","penChat":"general_penChat__Qv0Ls"};